<ada-card
	#HousekeepingPropertiesCard
	id="HousekeepingPropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="Housekeeping Properties"
		data-container-selector="ada-card-header"
		id="HousekeepingPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<ada-text
			#CompletionStateLabel
			id="CompletionStateLabel"
			[content]="'Completion State'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CompletionStateDisplay
				id="CompletionStateDisplay"
				[content]="currentPropertyObject?.CompletionState ? 'Completed' : 'Not Completed'"
			/>
		</ada-container>
		<ada-text
			#CheckedOutStateLabel
			id="CheckedOutStateLabel"
			[content]="'Checked Out State'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CheckedOutStateDisplay
				id="CheckedOutStateDisplay"
				[content]="currentPropertyObject?.CheckedOutState ? 'Checked Out' : 'Not Checked Out'"
			/>
		</ada-container>
		<ada-text
			#PublicationStateLabel
			id="PublicationStateLabel"
			[content]="'Publication State'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-combo
				#PublicationStateDisplay
				id="PublicationStateDisplay"
				[isDisabled]="true"
				[options]="publicationStateOptions"
				[value]="currentPropertyObject?.PublicationState"
			/>
		</ada-container>
		<ada-text
			#DeletedStateLabel
			id="DeletedStateLabel"
			[content]="'Deletion State'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-combo
				#DeletedStateDisplay
				id="DeletedStateDisplay"
				[isDisabled]="true"
				[options]="deletedStateOptions"
				[value]="currentPropertyObject?.DeletedState"
			/>
		</ada-container>
		<ada-text
			#ApprovedForPublicationStateLabel
			id="ApprovedForPublicationStateLabel"
			[content]="'Approved For Publication State'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#ApprovedForPublicationStateDisplay
				id="ApprovedForPublicationStateDisplay"
				[content]="currentPropertyObject?.ApprovedForPublicationState"
			/>
		</ada-container>
		<ada-text
			#CreatedByLabel
			id="CreatedByLabel"
			[content]="'Created By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CreatedByDisplay
				id="CreatedByDisplay"
				[content]="currentPropertyObject?.CreatedBy || '--'"
			/>
		</ada-container>
		<ada-text
			#CreationDateLabel
			id="CreationDateLabel"
			[content]="'Creation Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CreationDateDisplay
				id="CreationDateDisplay"
				[content]="currentPropertyObject?.CreationDate ? (currentPropertyObject?.CreationDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#UpdatedByLabel
			id="UpdatedByLabel"
			[content]="'Updated By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#UpdatedByDisplay
				id="UpdatedByDisplay"
				[content]="currentPropertyObject?.UpdatedBy || '--'"
			/>
		</ada-container>
		<ada-text
			#UpdationDateLabel
			id="UpdationDateLabel"
			[content]="'Last Updated Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#UpdationDateDisplay
				id="UpdationDateDisplay"
				[content]="currentPropertyObject?.UpdationDate ? (currentPropertyObject.UpdationDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#DeletedByLabel
			id="DeletedByLabel"
			[content]="'Deleted By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#DeletedByDisplay
				id="DeletedByDisplay"
				[content]="currentPropertyObject?.DeletedBy || '--'"
			/>
		</ada-container>
		<ada-text
			#DeletionDateLabel
			id="DeletionDateLabel"
			[content]="'Deletion Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#DeletionDateDisplay
				id="DeletionDateDisplay"
				[content]="currentPropertyObject?.DeletionDate ? (currentPropertyObject?.DeletionDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#CheckedInByLabel
			id="CheckedInByLabel"
			[content]="'Checked In By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CheckedInByDisplay
				id="CheckedInByDisplay"
				[content]="currentPropertyObject?.CheckedInBy || '--'"
			/>
		</ada-container>
		<ada-text
			#CheckedInDateLabel
			id="CheckedInDateLabel"
			[content]="'Checked In Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CheckedInDateDisplay
				id="CheckedInDateDisplay"
				[content]="currentPropertyObject?.CheckedInDate ? (currentPropertyObject?.CheckedInDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#CheckedOutByLabel
			id="CheckedOutByLabel"
			[content]="'Checked Out By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CheckedOutByDisplay
				id="CheckedOutByDisplay"
				[content]="currentPropertyObject?.CheckedOutBy || '--'"
			/>
		</ada-container>
		<ada-text
			#CheckedOutDateLabel
			id="CheckedOutDateLabel"
			[content]="'Checked Out Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#CheckedOutDateDisplay
				id="CheckedOutDateDisplay"
				[content]="currentPropertyObject?.CheckedOutDate ? (currentPropertyObject.CheckedOutDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#ApprovedByLabel
			id="ApprovedByLabel"
			[content]="'Approved By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#ApprovedByDisplay
				id="ApprovedByDisplay"
				[content]="currentPropertyObject?.ApprovedBy || '--'"
			/>
		</ada-container>
		<ada-text
			#ApprovalDateLabel
			id="ApprovalDateLabel"
			[content]="'Approval Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#ApprovalDateDisplay
				id="ApprovalDateDisplay"
				[content]="currentPropertyObject?.ApprovalDate ? (currentPropertyObject?.ApprovalDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#UnapprovedByLabel
			id="UnapprovedByLabel"
			[content]="'Unapproved By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#UnapprovedByDisplay
				id="UnapprovedByDisplay"
				[content]="currentPropertyObject?.UnapprovedBy || '--'"
			/>
		</ada-container>
		<ada-text
			#UnapprovalDateLabel
			id="UnapprovalDateLabel"
			[content]="'Unapproval Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#UnapprovalDateDisplay
				id="UnapprovalDateDisplay"
				[content]="currentPropertyObject?.UnapprovalDate ? (currentPropertyObject?.UnapprovalDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#PublishedByLabel
			id="PublishedByLabel"
			[content]="'Published By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#PublishedByDisplay
				id="PublishedByDisplay"
				[content]="currentPropertyObject?.PublishedBy || '--'"
			/>
		</ada-container>
		<ada-text
			#PublishedDateLabel
			id="PublishedDateLabel"
			[content]="'Published Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#PublishedDateDisplay
				id="PublishedDateDisplay"
				[content]="currentPropertyObject?.PublishedDate ? (currentPropertyObject?.PublishedDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#UnpublishedByLabel
			id="UnpublishedByLabel"
			[content]="'Unpublished By'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#UnpublishedByDisplay
				id="UnpublishedByDisplay"
				[content]="currentPropertyObject?.UnpublishedBy || '--'"
			/>
		</ada-container>
		<ada-text
			#UnpublishedDateLabel
			id="UnpublishedDateLabel"
			[content]="'Unpublished Date'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#UnpublishedDateDisplay
				id="UnpublishedDateDisplay"
				[content]="currentPropertyObject?.UnpublishedDate ? (currentPropertyObject?.UnpublishedDate | adaLocalizedDate: 'short') : '--'"
			/>
		</ada-container>
		<ada-text
			#LastRejectionReasonLabel
			id="LastRejectionReasonLabel"
			[content]="'Last Rejection Reason'"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colSpan]="3"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-text
				#LastRejectionReasonDisplay
				id="LastRejectionReasonDisplay"
				[content]="currentPropertyObject?.LastRejectionReason || '--'"
			/>
		</ada-container>
		<ada-text content="Tested" />
		<ada-toggle-switch
			data-testid="housekeeping-properties-tested-toggle"
			[isDisabled]="isDisabled"
			[isToggled]="currentPropertyObject?.Tested"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			(isToggledChange)="setObjectPropertyValue('Tested', $event)"
		/>
		<ada-text content="Notes" />
		<ada-input
			data-testid="housekeeping-properties-notes-input"
			minHeight="8rem"
			type="textarea"
			[isDisabled]="isDisabled"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			[showAsFullWidth]="true"
			[value]="currentPropertyObject?.Notes"
			(valueChange)="setObjectPropertyValue('Notes', $event)"
		/>
	</ada-container>
</ada-card>
